export interface IZipcodeAddress {
	street: string;
	district: string;
	city: string;
	state: string;
}

/**
 * Consulta o CEP no ViaCEP. Devolve `null` quando o CEP não existe e lança erro quando o serviço não responde,
 * para a tela diferenciar "CEP não encontrado" de "não foi possível consultar".
 */
export const searchZipcode = async (zipcode: string): Promise<IZipcodeAddress | null> => {
	const digits = String(zipcode ?? "").replace(/\D/g, "");
	if (digits.length !== 8) return null;

	const response = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
	if (!response.ok) throw new Error("Não foi possível consultar o CEP.");

	const data = await response.json();
	if (data?.erro) return null;

	return {
		street: data.logradouro ?? "",
		district: data.bairro ?? "",
		city: data.localidade ?? "",
		state: data.uf ?? "",
	};
};
